// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__ulzqp","content":"styles_content__3jY4A","selectAll":"styles_selectAll__2xxds"};